import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import BackButtonHub from '../../../../../../../../components/shared/BackButtonHub';
import {
  ChevronRightIcon,
  QrCodeScannerRoundedIcon,
} from '../../../../../../../../assets/Icons';
import { useDispatch, useSelector } from 'react-redux';
import { changePageTransaction } from '../../../../../../../../store/Routing/transactionRouting';
import CustomButton from '../../../../../../../../components/shared/CustomButton';
import { useState } from 'react';
import ScannedDataAcceptTransaction from './ScannedDataAcceptTransaction';
import UnscannedDataAcceptTransaction from './UnscannedDataAcceptTransaction';
import { getAllDataAcceptTransactionScan } from '../../../../../../../../store/transaction/request/acceptDataTransaction';
import { updateTransactionData } from '../../../../../../../../api/transaction';
import { getIdDetailTransactionRequest } from '../../../../../../../../store/transaction/request/detailTransactionRequest';

const AcceptTransactionMobile = () => {
  const dispatch = useDispatch();
  const idTransaction = useSelector(getIdDetailTransactionRequest);

  const [isScanned, setIsScanned] = useState(true);
  const {
    isExist,
    scanned,
    idScanned,
    allData,
    allDataWithQr,
    detail,
    rackId,
    noqr,
    noqrid,
    dataRackDetail,
    isSelect,
  } = useSelector(getAllDataAcceptTransactionScan);

  const handleToScanMore = () => {
    if (
      allData.filter((list) => !idScanned.includes(list.encript)).length !== 0
    ) {
      dispatch(changePageTransaction('ProccessScanAccept'));
    } else {
    }
  };

  const handleSend = async () => {
    const qr = scanned?.flat().map((item, idx) => item?.encript);

    const params = {
      status: 'accept',
      produk_qr: qr,
      photo: noqrid,

      id_rack_position: rackId,
    };

    try {
      const data = await updateTransactionData(idTransaction, params);
      dispatch(changePageTransaction('detailRequestTransaction'));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box sx={{ paddingTop: 2 }}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <BackButtonHub
          onClick={() => {
            dispatch(changePageTransaction('detailRequestTransaction'));
          }}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              display: 'flex',
              gap: 0,
              alignItems: 'center',
              color: '#9E9D9D',
            }}
          >
            <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
              Stock request details
            </Typography>
            <ChevronRightIcon />
            <Typography
              sx={{ fontSize: '14px', fontWeight: 600, color: '#000000' }}
            >
              Accept
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '10px', fontWeight: 600 }}>
              {dataRackDetail?.namaHub}
            </Typography>
            <ChevronRightIcon sx={{ fontSize: '12px' }} />
            <Typography sx={{ fontSize: '10px', fontWeight: 600 }}>
              {dataRackDetail?.name}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* head */}
      <Grid
        container
        columns={2}
        columnSpacing={0.5}
        sx={{
          mt: '16px',
          p: '4px',
          bgcolor: '#F5F5F5',
          borderRadius: '8px',
        }}
      >
        <Grid item xs={1}>
          <Box
            sx={{
              py: '8px',
              borderRadius: '8px',
              bgcolor: isScanned ? 'white' : '#F5F5F5',
            }}
            onClick={() => setIsScanned(true)}
          >
            <Typography
              sx={{
                fontSize: '14px',
                textAlign: 'center',
                fontWeight: isScanned ? '600' : '500',
                color: isScanned ? '#51B15C' : 'black',
              }}
            >
              Scanned {noqr?.flat().length + scanned?.length}
              {/* {scanned.length + noqr.flat().length} */}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Box
            sx={{
              py: '8px',
              borderRadius: '8px',
              bgcolor: !isScanned ? 'white' : '#F5F5F5',
            }}
            onClick={() => setIsScanned(false)}
          >
            <Typography
              sx={{
                fontSize: '14px',
                textAlign: 'center',
                fontWeight: !isScanned ? '600' : '500',
                color: !isScanned ? '#51B15C' : 'black',
              }}
            >
              Unscanned{' '}
              {/* {noqr.flat().length +
                allDataWithQr.length -
                scanned.flat().length || 0} */}
              {/* {allDataWithQr.length -
                scanned.flat().length +
                allData?.filter(
                  (list) =>
                    list.qrcodeType === false &&
                    !noqrid?.some((item) =>
                      item.id_detail.includes(list.iddetailSti)
                    )
                ).length || 0} */}
              {allDataWithQr[0]?.jumlah -
                scanned?.flat().length +
                allData?.filter(
                  (list) =>
                    list.qrcodeType === false &&
                    !noqrid?.some((item) =>
                      item.id_detail.includes(list.iddetailSti)
                    )
                ).length || 0}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* data scan */}
      <Box sx={{ minHeight: '70vh', bgcolor: 'white' }}>
        {isScanned ? (
          <ScannedDataAcceptTransaction />
        ) : (
          <UnscannedDataAcceptTransaction />
        )}
      </Box>

      {/* button event */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          bgcolor: 'white',
          p: '20px',
          width: '100%',
          display: 'flex',
          gap: 2,
        }}
      >
        <CustomButton
          variant="contained"
          sx={{ width: '100%' }}
          onClick={() => handleSend()}
          disabled={
            allData.filter(
              (list) =>
                list.qrcodeType === true && !idScanned.includes(list.idProduk)
            ).length +
              allData?.filter(
                (list) =>
                  list.qrcodeType === false &&
                  !noqrid?.some((item) =>
                    item.id_detail.includes(list.iddetailSti)
                  )
              ).length !==
            0
          }
        >
          Accept
        </CustomButton>
        {isSelect ? (
          <Box
            sx={{
              border: 2,
              borderRadius: '8px',
              borderColor: '#51B15C',
              width: '40px',
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={() =>
              dispatch(changePageTransaction('imageCaptureAcceptTransaction'))
            } //TODO : scan no qr
          >
            <QrCodeScannerRoundedIcon sx={{ color: '#51B15C' }} />
          </Box>
        ) : (
          <Box
            sx={{
              border: 2,
              borderRadius: '8px',
              borderColor: '#51B15C',
              width: '40px',
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={() => handleToScanMore()}
          >
            <QrCodeScannerRoundedIcon
              sx={{
                color:
                  allData.filter((list) => !idScanned.includes(list.idProduk))
                    .length === 0
                    ? '#9D9E9E'
                    : '#51B15C',
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AcceptTransactionMobile;
